import { emptySplitApi } from "./empty-split-api";
import {
  Insurer,
  InsurerCreate,
  InsurerUpdate,
  InsurersCountResponse,
  InsurersFilters,
  InsurersResponse
} from "./types/insurers.type";

export const insurersApi: any = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getInsurers: builder.query<InsurersResponse, InsurersFilters>({
      query: ({
        limit = 300,
        offset = 0,
        query = "{*}",
        search,
        ...params
      }) => ({
        url: `/insurers/`,
        params: {
          limit,
          offset,
          query,
          search: search && encodeURIComponent(search),
          ...params
        }
      }),
      providesTags: ["Insurers"]
    }),
    getInsurersCount: builder.query<InsurersCountResponse, InsurersFilters>({
      query: ({
        query = "{*}",
        search,
        limit: _limit,
        offset: _offset,
        ...params
      }) => ({
        url: `/insurers/count/`,
        params: {
          query,
          search: search && encodeURIComponent(search),
          ...params
        }
      }),
      providesTags: ["Insurers"]
    }),
    createInsurer: builder.mutation<Insurer, InsurerCreate>({
      query: (body) => ({
        url: "/insurers/",
        method: "POST",
        body: { ...body, phone: body.phone?.replace(/\D/g, "") }
      }),
      invalidatesTags: ["Insurers"]
    }),
    updateInsurer: builder.mutation<Insurer, InsurerUpdate>({
      query: ({ id, ...body }) => ({
        url: `/insurers/${id}/`,
        method: "PATCH",
        body: { ...body, phone: body.phone?.replace(/\D/g, "") }
      }),
      invalidatesTags: ["Insurers"]
    }),
    deleteInsurer: builder.mutation<Insurer, { id: number }>({
      query: ({ id }) => ({
        url: `/insurers/${id}/`,
        method: "DELETE"
      }),
      invalidatesTags: ["Insurers"]
    })
  })
});

export const {
  useGetInsurersQuery,
  useGetInsurersCountQuery,
  useDeleteInsurerMutation,
  useCreateInsurerMutation,
  useUpdateInsurerMutation
} = insurersApi;
